// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"zz","title":"Az","nav":"Bz","flexCell":"Cz","facetLink":"Dz"};